import { render, staticRenderFns } from "./storyItem.vue?vue&type=template&id=a227666a&scoped=true&lang=true&"
import script from "./storyItem.vue?vue&type=script&lang=js&"
export * from "./storyItem.vue?vue&type=script&lang=js&"
import style0 from "./storyItem.vue?vue&type=style&index=0&id=a227666a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a227666a",
  null
  
)

export default component.exports